import { render, staticRenderFns } from "./figuresImportIncomeStatement.vue?vue&type=template&id=39232049&scoped=true"
import script from "./figuresImportIncomeStatement.vue?vue&type=script&lang=js"
export * from "./figuresImportIncomeStatement.vue?vue&type=script&lang=js"
import style0 from "./figuresImportIncomeStatement.vue?vue&type=style&index=0&id=39232049&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39232049",
  null
  
)

export default component.exports